<template>
  <v-container v-if="showForm" class="grey lighten-5">
    <v-row class="justify-start">
      <div class="FormCard-container bg-lightYellow pa-8">
        <p class="ma-0 mb-4 f-12 primary--text">Cadastro de Novo cartão</p>
        <v-form v-model="form.isFormValid">
          <v-text-field
            label="Número do Cartão"
            v-model="form.number"
            v-mask="maskCardNumber"
            :rules="cardNumberRules"
            background-color="#F7F7F7"
            hide-details="auto"
            class="mt-6"
            solo
            flat
          />
          <v-text-field
            label="Nome do Titular (conforme o cartão)"
            v-model="form.cardholder"
            :rules="rules"
            background-color="#F7F7F7"
            hide-details="auto"
            class="mt-6"
            solo
            flat
          />
          <v-row class="justify-center mt-2">
            <v-col class="col-12 col-md-6 py-0">
              <v-text-field
                label="Data de Vencimento"
                v-model="form.due_date"
                v-mask="maskDueDate"
                :rules="dueDateRules"
                background-color="#F7F7F7"
                hide-details="auto"
                class="mt-6"
                solo
                flat
              />
            </v-col>
            <v-col class="col-12 col-md-6 py-0">
              <v-text-field
                label="CVV"
                v-model="form.cvv"
                v-mask="maskCvv"
                :rules="cvvRules"
                background-color="#F7F7F7"
                hide-details="auto"
                class="mt-6"
                solo
                flat
              />
            </v-col>
          </v-row>
          <div class="d-flex align-center justify-space-around text-center mt-6">
            <v-btn @click="close" class="br-8 mt-8" height="40" width="170" color="primary">
              Cancelar
            </v-btn>

            <v-btn
              @click="saveCardMethod(form)"
              :disabled="!form.isFormValid || isLoading"
              class="br-8 mt-8"
              height="40"
              width="170"
              color="secondary"
            >
              Salvar
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  props: {
    type: { type: String },
    saveCardMethod: { type: Function },
    showForm:  { type: Boolean }
  },
  data() {
    return {
      showForm: false,
      form: {
        cardholder: '',
        id: '',
        isFormValid: false,
        number: '',
        due_date: '',
        cvv: '',
      },
      maskDueDate: '##/##',
      maskCardNumber: '#### #### #### ####',
      maskCvv: '###',
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      cardNumberRules: [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => (v && v.length > 18) || 'O cartão tem que ser digitado completamente',
      ],
      dueDateRules: [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => (v && v.length > 4) || 'A data tem que estar digitada completamente',
      ],
      cvvRules: [
        (v) => !!v || 'Esse campo é obrigatório',
        (v) => (v && v.length > 2) || 'O cvv tem que ser digitado completamente',
      ],
    };
  },
  methods: {
    show(formCreditCard = {}) {
      this.form = {
        isFormValid: !formCreditCard.id,
        cardholder: formCreditCard.cardholder,
        number: formCreditCard.number,
        due_date: formCreditCard.due_date,
        cvv: formCreditCard.cvv,
        ...formCreditCard,
      };
      this.showForm = true;
    },
    close() {
      this.showForm = false;
    },
  },
  directives: {
    mask,
  },
};
</script>

<style>
.FormCard-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
</style>
